import { Tooltip } from 'antd'
import Img_tooltip from '@/assets/image/field_tip.svg'
import styles from './index.module.less'
import classNames from 'classnames'
const MeToolTip = ({
  title = '',
  tip = '',
  className,
}: {
  title: string
  tip: string
  className?: string
}) => {
  return (
    <div className={classNames(styles.wrap)}>
      <span className={styles.text}>
        <span className={classNames(className, { [styles.textSpan]: true })}>{title} </span>
        <Tooltip title={tip} placement="top">
          <img className={styles.tips_icon} src={Img_tooltip} alt="" />
        </Tooltip>
      </span>
    </div>
  )
}

export default MeToolTip
